import React from 'react';
import s from './ProductCardHero.module.css';
import Container from '../Container/Container';

function ProductCardHero({ text, title, sendUrl }) {
  const url = sendUrl;
  return (
    <div
      style={{
        backgroundImage: `url(${url})`,
      }}
      className={s.ProductCardHero}
    >
      <Container>
        <div className={s.ProductCardHeroContainer}>
          <p className={s.ProductCardHeroText}>{text}</p>
          <h2 className={s.ProductCardHeroTitle}>{title}</h2>
        </div>
      </Container>
    </div>
  );
}

export default ProductCardHero;
